import { gql } from "@apollo/client";
import StripePlanFields from "~/lib/queries/fragments/StripePlanFields";
import CompanyPlanUsageFields from "~/lib/queries/fragments/CompanyPlanUsageFields";

export default gql`
  mutation SaveVendorSharing($companyId: ObjectId!, $enabledSharing: Boolean!, $sharing: CompanySharingInput!) {
    saveCompanySharing(companyId: $companyId, enabledSharing: $enabledSharing, sharing: $sharing) {
      _id
      enabledSharing
      sharing {
        products
        stories
        projects
        products
        resources
        groups
        governments
        newsworthy
        highlights
        team
      }
      stripePlan {
        ...StripePlanFields
      }
      planUsage {
        ...CompanyPlanUsageFields
      }
    }
  }

  ${CompanyPlanUsageFields}
  ${StripePlanFields}
`;
